export default "__VITE_ASSET__BxYo0Rzp__"